import styled from 'styled-components/macro';

export const HomePageWrapper = styled.div`
  width: 100%;
  .title {
    font-size: 20px;
    color: var(--color-11);
    font-weight: 600;
    margin-bottom: 16px;
  }
  .box-left-overview {
    border: 1px solid var(--color-4);
    padding: 10px;
    border-radius: 10px;
    height: 100%;
    width: 100%;
  }
  .sub-title {
    font-size: 16px;
    font-weight: 600;
  }
  .see-all {
    margin-left: auto;
    color: var(--color-4);
    cursor: pointer;
    font-size: 14px;
    border-bottom: 1px solid var(--color-4);
    min-width: fit-content;
    max-height: fit-content;
    i {
      margin-left: 6px;
    }
    &:hover {
      opacity: 0.8;
    }
  }
  .box-item {
    margin-top: 10px;
    border: 1px solid var(--color-4);
    padding: 10px;
    border-radius: 10px;
    display: flex;
    align-items: center;
  }
  .item-title {
    font-weight: 600;
    color: var(--color-4);
    margin-bottom: 6px;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
  }
  .item-sub-title {
    color: var(--color-12);
    font-size: 14px;
  }
  .item-sub-title-remain {
    color: var(--color-12);
    font-size: 14px;
  }
  .item-sub-title-remain-time {
    color: var(--color-4);
    font-size: 14px;
  }
  .item-button {
    background-color: var(--color-4);
    color: var(--color-13);
    padding: 8px 12px;
    border-radius: 6px;
    min-width: fit-content;
    cursor: pointer;
    font-size: 14px;
    &:hover {
      opacity: 0.8;
    }
    margin-left: auto;
  }
  .box-right-overview {
    border: 1px solid var(--color-4);
    padding: 10px;
    border-radius: 10px;
    height: 100%;
    width: 100%;
  }
  .item-sub-title-date {
    color: var(--color-12);
    font-size: 14px;
  }
  .item-tag {
    background-color: var(--color-10);
    color: var(--color-13);
    padding: 8px 12px;
    border-radius: 20px;
    min-width: fit-content;
    margin-left: auto;
    font-size: 14px;
  }
  .box-data-overview {
    box-shadow: 0px 10px 10px 0px #00000026;
    background-color: var(--color-13);
    padding: 20px;
    border-radius: 10px;
    margin-top: 20px;
  }
  .box-item-data {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    border-left: 5px solid var(--color-4);
    border-radius: 10px;
    height: 100%;
    padding-left: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 10px;
  }
  .text-title-data {
    font-weight: 500;
    font-size: 14px;
    color: var(--color-12);
    margin: 0;
    margin-bottom: 8px;
  }
  .text-num-data {
    color: var(--color-11);
    font-weight: 600;
    font-size: 20px;
    padding: 4px 0px 12px;
  }
  .box-revenue-report {
    background-color: var(--color-2);
    padding: 20px;
    border-radius: 10px;
    margin-top: 20px;
  }
  .box-revenue-ratio {
    background-color: var(--color-2);
    padding: 20px;
    border-radius: 10px;
    margin-top: 20px;
  }
  .box-report-card {
    background-color: var(--color-13);
    box-shadow: 0px 4px 10px 0px #0000001a;
    padding: 20px;
    border-radius: 10px;
    height: 100%;
    @media (max-width: 768px) {
      padding: 16px 12px;
    }
  }
  .box-no-order {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex-direction: column;
    padding: 20px;
  }
`;
